<template>
  <div id="app">
    <topBar/>
    <div id="page" class="auto-style1">

      <div class="layout_gauche">
        <leftMenu/>
      </div>

      <div class="layout_droite">
        <vue-page-transition name="fade">
          <router-view :key="$route.fullPath"/>
        </vue-page-transition>
        <div id="scrollup">
          <img src="/images/haut.png" alt=""/>
        </div>
      </div>

    </div>

    <modals-container/>
    <v-dialog/>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import topBar from './components/Layout/MenuHaut';
  import leftMenu from './components/Layout/MenuGauche';
  import warningModal from './components/Layout/Avertissement';
  import $ from 'jquery';
  import 'whatwg-fetch';
  import Eventbus from './eventbus';

  import './stylesheets/index.scss';

  export default {
    name: 'app',
    computed: {
      notInMemberSection() {
        console.log('ROUTE NAME', this.$route.name);
        return this.$route.name.toLowerCase().indexOf('member') === -1;
      }
    },
    methods: {
      ...mapActions('orders', {
        getCart: 'getCart'
      }),
      ...mapActions('config', {
        fetchConfigs: 'fetchConfigs'
      }),
      showWarningModal() {
        this.$modal.show(
          warningModal,
          {},
          {
            height: 'auto',
            minHeight: 300,
            name: 'warningModal',
            root: this.$root
          }
        );
      }
    },
    async mounted() {
      this.fetchConfigs();
      this.getCart();
      Eventbus.$on('cart-updated', () => {
        this.$swal.fire({
          text: 'Le panier a été mis à jour',
          type: 'success',
          toast: true,
          position: 'top-end',
          timer: 3000,
          timerProgressBar: true,
          showConfirmButton: false
        });
      });

      this.showWarningModal()
    },
    components: { topBar, leftMenu, warningModal }
  };

  $(function() {
    // On cache le bouton de déroulement
    const scroll_button = $('#scrollup');

    // Déroulement de la fenêtre
    $(window).scroll(function() {
      if ($(this).scrollTop() >= 300) {
        // le chiffre (300) est la distance en pixels du haut de la page à partir de laquelle la flèche apparaît
        scroll_button.css('opacity', 1);
      }
      else {
        scroll_button.css('opacity', 0);
      }
    });

    scroll_button.click(function() {
      $('html,body').animate({ scrollTop: 0 }, 200); // le dernier chiffre (200) est la vitesse de retour en milisecondes
    });
  });
</script>

<style lang="scss">
  :root {
    --accent-color: #007bff;
    --primary-color: #fff;
    --dark-color: #000;
  }

  * {
    box-sizing: border-box;
  }
</style>

<style module>
  .menuContainer {
    position: fixed;
    left: 0;
    top: 0;
    height: 100vh;
    width: 100vw;
    background-color: var(--primary-color);
  }

</style>
